import { render, staticRenderFns } from "./VerifyAccount.vue?vue&type=template&id=72f7f02e&"
import script from "./VerifyAccount.vue?vue&type=script&lang=ts&"
export * from "./VerifyAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports